import { Instagram, Facebook, MapPin, Mail, Phone } from "lucide-react";
import { LogoMark } from "./brand";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#800020] text-[#f3e6df]"
    >
      <div className="gold-rule opacity-60" />
      <div className="max-w-7xl mx-auto px-6 sm:px-10 py-14 grid gap-12 md:grid-cols-4 items-start">
        {/* Brand */}
        <div className="space-y-4">
          <LogoMark className="h-12 w-auto opacity-95" viewBox="70 400 860 250" />
          <p className="font-serif-soft text-lg italic text-[#e9d3b6]/90 max-w-xs leading-relaxed">
            Caffè & Gelateria — a little corner of Italian dolce vita.
          </p>
        </div>

        {/* Locations */}
        <div className="space-y-4">
          <h3 className="text-xs uppercase tracking-[0.3em] text-[#D4AF37] font-semibold">
            Locations
          </h3>
          <a
            href="https://maps.google.com/?q=5241+Center+Blvd,+Long+Island+City,+NY+11101"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-location-1"
            className="flex items-start gap-3 group"
          >
            <MapPin className="h-4 w-4 mt-1 text-[#D4AF37] shrink-0" />
            <span className="font-sans text-sm text-[#f3e6df]/90 group-hover:text-white transition-colors">
              5241 Center Blvd
              <br />
              Long Island City, NY 11101
            </span>
          </a>
          <a
            href="https://maps.google.com/?q=227+West+St,+Greenpoint,+NY+11122"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-location-2"
            className="flex items-start gap-3 group"
          >
            <MapPin className="h-4 w-4 mt-1 text-[#D4AF37] shrink-0" />
            <span className="font-sans text-sm text-[#f3e6df]/90 group-hover:text-white transition-colors">
              227 West St
              <br />
              Greenpoint, NY 11122
            </span>
          </a>
        </div>

        {/* Contacts */}
        <div className="space-y-4">
          <h3 className="text-xs uppercase tracking-[0.3em] text-[#D4AF37] font-semibold">
            Contact
          </h3>
          <a
            href="tel:+19294245955"
            data-testid="footer-phone-link"
            className="flex items-start gap-3 group"
          >
            <Phone className="h-4 w-4 mt-1 text-[#D4AF37] shrink-0" />
            <span className="font-sans text-sm text-[#f3e6df]/90 group-hover:text-white transition-colors">
              +1 (929) 424-5955
            </span>
          </a>
          <a
            href="mailto:info@santachiaracaffe.com"
            data-testid="footer-email-link"
            className="flex items-start gap-3 group"
          >
            <Mail className="h-4 w-4 mt-1 text-[#D4AF37] shrink-0" />
            <span className="font-sans text-sm text-[#f3e6df]/90 group-hover:text-white transition-colors">
              info@santachiaracaffe.com
            </span>
          </a>
        </div>

        {/* Social */}
        <div className="space-y-4 md:justify-self-end">
          <h3 className="text-xs uppercase tracking-[0.3em] text-[#D4AF37] font-semibold">
            Follow us
          </h3>
          <div className="flex items-center gap-4">
            <a
              href="https://www.instagram.com"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
              data-testid="footer-instagram"
              className="h-11 w-11 grid place-items-center rounded-full border border-[#D4AF37]/50 text-[#e9d3b6] hover:bg-[#D4AF37] hover:text-[#800020] hover:border-[#D4AF37] transition-all duration-300"
            >
              <Instagram className="h-5 w-5" />
            </a>
            <a
              href="https://www.facebook.com"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
              data-testid="footer-facebook"
              className="h-11 w-11 grid place-items-center rounded-full border border-[#D4AF37]/50 text-[#e9d3b6] hover:bg-[#D4AF37] hover:text-[#800020] hover:border-[#D4AF37] transition-all duration-300"
            >
              <Facebook className="h-5 w-5" />
            </a>
          </div>
        </div>
      </div>

      <div className="border-t border-white/15">
        <div className="max-w-7xl mx-auto px-6 sm:px-10 py-5 flex flex-col sm:flex-row items-center justify-between gap-2">
          <p className="text-xs text-[#f3e6df]/70 tracking-wide">
            © {new Date().getFullYear()} Santa Chiara Caffè & Gelateria
          </p>
          <p className="text-xs text-[#f3e6df]/70 tracking-[0.2em] uppercase">
            Made in Italy
          </p>
        </div>
      </div>
    </footer>
  );
};
